import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { startCase, chain } from 'lodash';
import ValueEditor from '@/components/ValueEditor.vue';
const characterAdvancementsModule = namespace('characterAdvancements');
let CharacterSheetExperience = class CharacterSheetExperience extends Vue {
    constructor() {
        super(...arguments);
        this.isExperienceOpen = false;
        this.newValue = 0;
        this.startCase = startCase;
    }
    created() {
        this.fetchCharacterAdvancements();
    }
    get percentExperience() {
        const xp = this.completeCharacter.experiencePoints;
        return 100 * (xp.current - xp.previousLevel) / (xp.nextLevel - xp.previousLevel);
    }
    get experienceText() {
        return `${this.completeCharacter.experiencePoints.current} / ${this.completeCharacter.experiencePoints.nextLevel}`;
    }
    calculateLevel(experience) {
        const level = chain(this.characterAdvancements)
            .sortBy('experiencePoints')
            .findIndex(({ experiencePoints }) => experiencePoints > experience)
            .value();
        return level < 0 ? 20 : level;
    }
    getNextAdvancement(experience) {
        const advancement = chain(this.characterAdvancements)
            .sortBy('experiencePoints')
            .find(({ experiencePoints }) => experiencePoints > experience)
            .value();
        return advancement || {
            level: 20,
            experiencePoints: 355000
        };
    }
    updateExperience(newExperience) {
        const unspentLevels = this.calculateLevel(newExperience) - this.completeCharacter.currentLevel;
        this.$emit('updateCharacter', { experiencePoints: newExperience, currentStats: { unspentLevels } });
        this.isExperienceOpen = false;
    }
};
__decorate([
    Prop(Object)
], CharacterSheetExperience.prototype, "completeCharacter", void 0);
__decorate([
    characterAdvancementsModule.State
], CharacterSheetExperience.prototype, "characterAdvancements", void 0);
__decorate([
    characterAdvancementsModule.Action
], CharacterSheetExperience.prototype, "fetchCharacterAdvancements", void 0);
CharacterSheetExperience = __decorate([
    Component({
        components: {
            ValueEditor
        }
    })
], CharacterSheetExperience);
export default CharacterSheetExperience;
